import React, { Fragment, useState, useEffect } from 'react';
import ErrorBoundary from 'components/Layout/ErrorBoundary';
import Header from '../../views/Global/header';
import Notifications from 'react-notify-toast';
import EmptyLoader from './../../views/Global/Loaders/EmptyLoader';
import StaticFooter from './../../views/Global/staticFooter';
import Utils from './../../app/utils';
import Footer from '@tgslabs/footer/build/';
import APP from 'app';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import getFooterData from '../../actions/footerAction';
import getTranslationData from '../../services/getTranslationData';

const { emailData = '', contact = '', companyName = '', year = '', staticFooter = false, defaultLogo = '', clientType = '' } = APP.Utils.getConfig();
const { extractKeysFromUrl, isB2cClient, translateData, translateText } = Utils;

let flag = false;
const b2c = isB2cClient();

const masterLayout = (props) => {

    const [loader, setLoader] = useState(false);
    const [onlineStatus, setOnlineStatus] = useState(true);
    let showHeader = true;
    let showFooter = true;
    let stopCallmake = false;
    const queryParams = extractKeysFromUrl(location.search);
    const pathName = window.location.pathname || ""
    const { hideHeader = '', hideFooter = '', stopCall = "" } = queryParams;
    if (hideHeader == 1) {
        showHeader = false;
    }
    if (hideFooter == 1) {
        showFooter = false;
    }
    if (stopCall == 1 || pathName == "/hotel/hcn-update") {
        stopCallmake = true;
    }

    useEffect(() => {
        if (!stopCallmake) {
            props.dispatch(getFooterData());
            getTranslationData({
                key: 'language-translate',
                type: 'language-translate'
            });
        }
        setLoader(true);

        window.addEventListener('online', () => setOnlineStatus(true));
        window.addEventListener('offline', () => setOnlineStatus(false));
        return () => {
            window.removeEventListener('online', setOnlineStatus);
            window.removeEventListener('offline', setOnlineStatus);
        };
    }, []);

    // hide header functionality
    // can be used where we need to hide header
    const { logoUrl = '' } = props;
    const { emailId = '', contactUs = '', domainName = '', logoUpload = {} } = APP.Utils.fetchInfoData();
    const {
        logo = '', clientType: _clientType = clientType,
    } = APP.Utils.fetchGlobal();
    const _isWhitelabel = APP.Utils.isWhitelabel();

    const _isSearchPage = (location.pathname == "/hotel/" || location.pathname == "/hotel");
    const _themeModifier = APP.Utils.classNames('master-layout', {
        'master-layout--b2cSearchBox': _clientType == 'b2c' && _isSearchPage,
        'master-layout--b2c': _clientType == 'b2c' && !_isSearchPage,
    })
    if (!onlineStatus) { APP.Utils.errorToaster(translateText('offline', 'errors')); flag = true; };
    if (onlineStatus && flag) { APP.Utils.errorToaster(translateText('backOnline', 'errors'), 5000, 'success'); flag = false; };
    const footerLinksData = !b2c ? translateData(props.footerLinks, 'Footer') : translateData(props.footerLinks, 'B2CFooter');
    const footerTop = {
        heading: translateText('footerTopHeading', 'Footer'),
        subHeading: translateText('footerTopSubHeading', 'Footer'),
        emailUsText: translateText('emailUsText', 'Footer'),
        callUsText: translateText('callUsText', 'Footer')
    }
    return (
        <Fragment>
            <div className={_themeModifier}>
                <ErrorBoundary>
                    {showHeader && <Header isB2C={b2c} isSearchPage={_isSearchPage} />}
                    {!loader ? <EmptyLoader /> :
                        <Fragment>
                            <Notifications options={{ zIndex: 9999 }} />
                            {props.children}
                        </Fragment>
                    }
                    {showFooter ?
                        <Footer
                            logoUrl={logoUrl ? logoUrl : _isWhitelabel ? logo : defaultLogo}
                            emailData={_isWhitelabel ? emailId : emailData}
                            contact={_isWhitelabel ? contactUs : contact}
                            comapnyName={_isWhitelabel ? domainName : companyName}
                            year={year}
                            footerData={footerLinksData}
                            isB2C={b2c}
                            productType={'hotel'}
                            metaData={props.metaData}
                            footerTop={footerTop}
                            rightsReservedText={translateText('rightsReservedText', 'Footer')}
                        />

                        : ''
                    }
                </ErrorBoundary>
            </div>
        </Fragment>
    )
}

const mapStateToProps = state => {
    const { footerData = {} } = state,
        { footerLinks = [], metaData = {} } = footerData;
    return {
        footerLinks: footerLinks,
        metaData: metaData
    }
};

const mapDispatchToProps = dispatch => {
    let actions = bindActionCreators({
        getFooterData,
    });
    return { actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(masterLayout);
